import apiClient from '@/services/apiClient';
import type { ConfirmPaymentRequestDto, ConfirmPaymentResponseDto, FailPaymentRequestDto, FailPaymentResponseDto } from '@/types/api/payment';

/**
 * 토스 결제 성공 후 Medicrew API 승인 (서버에서 토스 승인·주문 확정).
 * POST /payment/confirm — Swagger ConfirmPaymentRequestDto
 */
export async function confirmMedicrewPayment(
    body: ConfirmPaymentRequestDto,
    currency?: string
): Promise<ConfirmPaymentResponseDto> {
    return apiClient.post<ConfirmPaymentResponseDto>('/payment/confirm', {
        ...body,
        currency: currency || 'KRW',
    });
}

/**
 * 토스 결제 실패 시 주문 상태 반영.
 * POST /payment/fail — Swagger FailPaymentRequestDto
 */
export async function failMedicrewPayment(body: FailPaymentRequestDto): Promise<FailPaymentResponseDto> {
    return apiClient.post<FailPaymentResponseDto>('/payment/fail', body);
}
